import InvoiceSettingServices from "@/services/InvoiceSettingServices.js";

export default {
  getInvoiceSettingAllNumberFormat: InvoiceSettingServices.getAllNumberFormat,
  getInvoiceSettingNumberFormat: InvoiceSettingServices.getNumberFormat,
  patchInvoiceSettingNumberFormat: InvoiceSettingServices.patchNumberFormat
}